import * as Classes from "./classes";
import { defineBaseFieldComponent } from "./baseField";
import type { AggregateFieldProps } from "../../types/skyward/treebrowse";

export const AggregateField = defineBaseFieldComponent<AggregateFieldProps, ReturnType<typeof formatField>>(
    {
        name: "aggregateField",
        additionalRowAttributes: () => ({ class: [Classes.treebrowserow, Classes.jsDraggable, Classes.fieldspan] }),
        nameCell: (field) => <td><span class=
            {{
                [Classes.column_content]: true,
                [Classes.treeBrowse]: true,
                [Classes.treeBrowseSectionHeader]: true,
                [Classes.selectable]: true,
                [Classes.nowrap]: true,
                [Classes.field]: true,
            }}>
            {formatLabel(field)}    
        </span></td>,
        typeIcon: (field) => window.skyward.reporting.getSvgNameByDataType(field.fieldType),
        fieldKey: (field) => "aggregate_" + field.columnId,
        formatField: formatField,
    }
);

function formatField(field: AggregateFieldProps)
{
    const result =
    {
        // These correspond to old data- attribute names, used in reporting and elsewhere
        sourceColumnId: field.columnId,
        columnFieldType: field.fieldType,
        // dynamic image columns only
        heightMultiplier: field.maxWidth / field.maxHeight,
        widthMultiplier: field.maxHeight / field.maxWidth,

        displayName: field.designerText,

        // for FormattedFieldProps
        fieldName: field.absoluteFieldPath
    };
    return result;
}

function formatLabel(field: AggregateFieldProps)
{
    if (field.aggregateType)
    {
        return `${field.aggregateType}: ${field.designerText}`;
    }

    return field.designerText;
}
